import { Trans } from 'react-i18next';
import { Button } from 'components/buttons/button';
import { ButtonMetadata, ButtonType } from 'components/buttons/button-types';
import styles from '../reward-details-card.module.scss';

function LabelsAndButtons({
  earnedAmount,
  earnStars,
  button,
  text,
  onClaim,
  analyticsComponentName = "button",
  analyticsAreaName,
  additionalMetaProperties
}: {
  earnedAmount?: string;
  earnStars?: string;
  button?: { text: string };
  text: string;
  onClaim?: () => void;
  analyticsComponentName?: string;
  analyticsAreaName?: string;
  additionalMetaProperties?: Partial<ButtonMetadata>;
}) {

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap gap-4 gap-md-0">
      <div className="d-flex justify-content-between flex-grow-1 align-items-center">
        <p className="m-0 flex-grow-1 text-label cust-pr-1">{text}</p>
        <p
          className={`${styles.stars} text-label text-label-bold text-primary mb-0 cust-mr-2 d-flex align-items-center justify-content-end`}
        >
          {!!earnedAmount && (
            <Trans
              i18nKey={'rewards.premium.unlockAmount'}
              default="Unlock {{ number }}%"
              values={{ number: earnedAmount }}
            />
          )}
          {earnStars && (
            <Trans
              i18nKey={'rewards.label.earnUpToStars'}
              default={'Earn up to {{number}} stars'}
              values={{ number: earnStars }}
              components={{ i: <i className="icon-star_full text-body-small ml-1" /> }}
            />
          )}
        </p>
      </div>
      <div className="flex-grow-1 flex-md-grow-0 d-flex justify-content-center justify-content-xs-end align-items-start">
        {button?.text && (
          <Button
            meta={{
              type: ButtonType.Primary,
              title: button?.text,
              areaName: analyticsAreaName,
              ...additionalMetaProperties
            }}
            onClick={onClaim}
            analyticsComponentName={analyticsComponentName}
          />
        )}
      </div>
    </div>
  );
}

export default LabelsAndButtons;